(function() {
    'use strict';

    angular.module('dashboardApp').service('Account', Service);

    Service.$inject = [
        'AppSettings',
        'RequestWrapper'
    ];


    function Service(
        AppSettings,
        RequestWrapper
    ) {


        this.updatePassword = function(oldPassword, newPassword) {
            var params = {
                oldPassword: oldPassword,
                newPassword: newPassword
            };
            var request = {
                url: AppSettings.paths.api + 'Account/UpdatePassword',
                data: $.param(params),
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            };

            return RequestWrapper.send(request);
        };


    }

})();
